import React, { PureComponent } from 'react';
import { themr } from 'react-css-themr';
import { EnhancedField } from 'common/components/core/form/Field';
import Switch from 'common/components/core/switch';
import { HelpTooltip } from 'common/components/core/help';
import defaultTheme from './VisitFrequencyInfo.scss';
import { Select } from 'common/components/core/select/Select';

class VisitFrequencyInfo extends PureComponent {
    handleDurationChange = value => {
        const { onChange } = this.props;
        onChange &&
            onChange({
                duration: value ? value.value : null
            });
    };
    handleRepeatCountChange = value => {
        const { onChange } = this.props;
        onChange &&
            onChange({
                repeatCount: value
            });
    };
    handleSpaceVisitsEvenlyChange = value => {
        const { onChange } = this.props;
        onChange &&
            onChange({
                spaceVisitsEvenly: value
            });
    };
    render() {
        const {
            theme,
            durationTitle,
            repeatCountTitle,
            spaceVisitsEvenlyTitle,
            repeatCount,
            defaultRepeatCount,
            repeatCountError,
            duration,
            defaultDuration,
            spaceVisitsEvenly,
            spaceVisitsEvenlyLabel,
            spaceVisitsEvenlyHelpText,
            durationTitleHelpText,
            repeatCountHelpText,
            planDurationPlaceholder,
            planningDurationInfo,
            ...others
        } = this.props;
        return (
            <div className={theme.visitFrequencyInfo}>
                <div className={theme.duration}>
                    <div className={theme.title}>
                        <div>{`${durationTitle}:`}</div>
                        {durationTitleHelpText ? (
                            <HelpTooltip tooltipText={durationTitleHelpText} />
                        ) : null}
                    </div>
                    <Select
                        placeholder={planDurationPlaceholder}
                        options={planningDurationInfo}
                        isSearchable={false}
                        isClearable
                        defaultValue={defaultDuration}
                        value={duration}
                        onChange={this.handleDurationChange}
                    />
                </div>
                <div className={theme.repeatCount}>
                    <div className={theme.title}>
                        <div>{`${repeatCountTitle}:`}</div>
                        {repeatCountHelpText ? (
                            <HelpTooltip tooltipText={repeatCountHelpText} />
                        ) : null}
                    </div>
                    <EnhancedField
                        type={'text'}
                        element={'input'}
                        value={repeatCount}
                        defaultValue={defaultRepeatCount}
                        onChange={this.handleRepeatCountChange}
                        error={repeatCountError}
                        theme={theme}
                    />
                </div>
                <div className={theme.spaceVisitsEvenly}>
                    <div className={theme.title}>
                        <div>{spaceVisitsEvenlyTitle}</div>
                        {spaceVisitsEvenlyHelpText ? (
                            <HelpTooltip
                                tooltipText={spaceVisitsEvenlyHelpText}
                            />
                        ) : null}
                    </div>
                    <Switch
                        {...others}
                        label={spaceVisitsEvenlyLabel}
                        onChange={this.handleSpaceVisitsEvenlyChange}
                        checked={spaceVisitsEvenly}
                    />
                </div>
            </div>
        );
    }
}

export default themr('visitFrequencyInfo', defaultTheme)(VisitFrequencyInfo);
